import React, { useMemo } from 'react'
import Box from '../Box'
import Flex from '../Flex'
import { BadgeProps } from './Badge.types'

const renderCount = (count, isPercentage) => {
  let countText = count
  if (!isPercentage && count > 100) {
    countText = 99
  }

  if (isPercentage && count >= 100) {
    countText = '100%'
  }

  if (isPercentage) {
    countText = `${count}%`
  }

  return countText
}

const Badge: React.FC<BadgeProps> = ({
  isPercentage,
  count,
  children,
  backgroundColor = 'red50',
  color = 'white',
  showZero = false,
  ...props
}) => {
  const isVisible = useMemo(() => showZero || count !== 0, [showZero, count])

  return (
    <Box position='relative' width='fit-content' height='fit-content' {...props}>
      {isVisible && (
        <Flex
          position='absolute'
          borderRadius='16px'
          backgroundColor={backgroundColor}
          top='-11px'
          right='-6px'
          px={isPercentage ? '6px' : count > 9 && '4px'}
          width='14px'
          height='14px'
          justifyContent='center'
          alignItems='center'
          color={color}
          fontSize='10px'
          fontWeight='bold'
        >
          {renderCount(count, isPercentage)}
        </Flex>
      )}

      {children}
    </Box>
  )
}

export default Badge
